import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useAppMutation } from "@shared/hooks/useAppMutation";
import type { NotificationId } from "@yalana/contracts";
import { useAuth } from "@features/auth";
import {
  notificationsMutations,
  notificationsQueries,
} from "../api/notifications.queries";

export function useNotifications() {
  const { user, authorizedTenants } = useAuth();
  const enabled = !!user && authorizedTenants.length > 0;

  const { data, isLoading } = useQuery({
    ...notificationsQueries.unread(),
    enabled,
    refetchInterval: enabled ? 30_000 : false,
  });

  return {
    notifications: data?.notifications ?? [],
    unreadCount: data?.unreadCount ?? 0,
    isLoading,
  };
}

export function useMarkRead() {
  const queryClient = useQueryClient();
  return useAppMutation({
    errorToast: "global",
    ...notificationsMutations.markRead("" as NotificationId),
    mutationFn: (id: NotificationId) =>
      notificationsMutations.markRead(id).mutationFn(),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: notificationsQueries.all(),
      });
    },
  });
}

export function useMarkAllRead() {
  const queryClient = useQueryClient();
  return useAppMutation({
    errorToast: "global",
    ...notificationsMutations.markAllRead(),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: notificationsQueries.all(),
      });
    },
  });
}
